@let isLoading = isLoading$ | async;
<mat-icon
  [class]="iconSizeClass || 'icon-size-6'"
  [class.text-yellow-500]="value && !isLoading"
  [class.text-default]="!dark && textDefaultColor && (!value || isLoading)"
  [class.text-gray-300]="!dark && !textDefaultColor && (!value || isLoading)"
  [class.text-white]="dark && !textDefaultColor && (!value || isLoading)"
  [class.opacity-70]="isLoading"
  [svgIcon]="(value || iconAlwaysFilled) ? 'heroicons_solid:star' : 'heroicons_outline:star-outline'"
  [matTooltip]="(readonly || isLoading) ? null : ((value ? 'Desfavoritar' : 'Favoritar') | transloco)"
/>
